module.exports = __webpack_public_path__ + "static/assets/3a9f7312dd51198c123804f87fa78bc9.png";